import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { isWithheld, talentPicture } from "components/Screens/Marketplace/Customer/utils/redaction";
import type { TalentListItem } from "components/Screens/Marketplace/Customer/types";
import "components/Screens/Marketplace/Customer/common/Withheld/Withheld.scss";
import "./Shortlist.scss";

function TalentAvatar({ talent, size = 48 }: { talent: TalentListItem; size?: number }) {
  const locked = isWithheld(talent, "profilePicture");
  const initials = `${talent.firstName?.[0] || ""}${talent.lastInitial || talent.lastName?.[0] || ""}`.toUpperCase();
  // A withheld photo shows the illustrated avatar for the talent's gender (or initials).
  const picture = talentPicture(talent);
  return (
    <span className="sl-avatar" style={{ width: size, height: size, fontSize: Math.round(size * 0.35) }}>
      {picture ? <img src={picture} alt="" /> : <span className="sl-avatar__ini">{initials}</span>}
      {locked && (
        <span className="avatar-lock sl-avatar__lock" aria-hidden="true">
          <LockOutlinedIcon />
        </span>
      )}
    </span>
  );
}

export default TalentAvatar;
